export const ConnectedAccountsOptions = ["ERP", "LabManagement", "RazorPayX"];
